import { useState } from "react";
import {
  FaUser,
  FaBuilding,
  FaUserTie,
  FaTools,
  FaWindowRestore,
  FaFileAlt,
} from "react-icons/fa";
import { Toast } from "../../common/Toast";
import CustomerReport from "./CustomerReport";
import SitesReport from "./SiteReport";
import ArchitectReport from "./ArchitectReport";
import WindowReport from "./WindowReport";
import ManualReport from "./ManualReport";
import MaterialReport from "./MaterialReport";
import FabricatorReport from "./FabricatorReport";

const menuItems = [
  { name: "Customer", icon: <FaUser /> },
  { name: "Architect", icon: <FaUserTie /> },
  { name: "Fabricator", icon: <FaTools /> },
  { name: "Site", icon: <FaBuilding /> },
  { name: "Window Quotation", icon: <FaWindowRestore /> },
  { name: "Manual Quotation", icon: <FaFileAlt /> },
  { name: "Material Quotation", icon: <FaFileAlt /> },
];

const Reports = () => {
  const [selectedItem, setSelectedItem] = useState("Customer");
  const filteredItems = menuItems.filter((item) => item.name.toLowerCase());

  const renderReportComponent = () => {
    switch (selectedItem) {
      case "Customer":
        return <CustomerReport />;
      case "Site":
        return <SitesReport />;
      case "Architect":
        return <ArchitectReport />;
      case "Fabricator":
        return <FabricatorReport />;
      case "Window Quotation":
        return <WindowReport />;
      case "Manual Quotation":
        return <ManualReport />;
      case "Material Quotation":
        return <MaterialReport />;
      default:
        return (
          <p className="text-gray-500">
            Type something to search reports or click on any section to view
            report list.
          </p>
        );
    }
  };

  return (
    <>
      <Toast />
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5">
        <div className="h-[calc(100vh-100px)] flex bg-white shadow-md rounded-md overflow-hidden border">
          {/* Left Sidebar (sticky full height) */}
          <div className="w-64 bg-white border-r p-4 overflow-y-auto sticky top-0 ">
            <ul className="space-y-2">
              {filteredItems.map((item, index) => (
                <li
                  key={index}
                  className={`flex items-center gap-2 p-2 rounded cursor-pointer hover:bg-secondary hover:text-white ${
                    selectedItem === item.name
                      ? "bg-primary text-white"
                      : "text-black"
                  }`}
                  onClick={() => setSelectedItem(item.name)}
                >
                  <span className="text-base">{item.icon}</span>
                  <span className="text-sm">{item.name}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Panel (independent scroll) */}
          <div className="flex-1 overflow-y-auto p-6 h-[calc(100vh-100px)]">
            {renderReportComponent()}
          </div>
        </div>
      </div>
    </>
  );
};

export default Reports;
